import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { createRadar, updateRadar } from '../../Chart/RadarChart/chart';

const Sleep = ({ healthReportData }) => {
  useEffect(() => {
    const radar_chart_data = healthReportData.sleep;
    var settings = {
      el: 'sleep_chart',
      margin: { top: 0, right: 0, bottom: 0, left: 0 },
      axes: [
        { line1: 'Sleep Duration', line2: '', anchor: 'middle' },
        { line1: 'Medication', line2: 'Requirement', anchor: 'end' },
        { line1: 'Sleep Quality', line2: '', anchor: 'end' },
        { line1: 'Sleep Efficiency', line2: '', anchor: 'end' },
        { line1: 'Daytime Dysfunction', line2: '', anchor: 'start' },
        { line1: 'Sleep Latency', line2: '', anchor: 'start' },
        { line1: 'Sleep Disturbance', line2: '', anchor: 'start' }
      ],
      range: {
        // TODO: KB should include this range in the data
        min: 0,
        max: 4
      },
      interpretations: ['Excellent', 'Good', 'Fair', 'Poor']
    };
    var sleep_data = {
      centerValue: radar_chart_data.psqi.value,
      chartData: [
        radar_chart_data['duration'].value,
        radar_chart_data['medication_requirement'].value,
        radar_chart_data['overall_quality'].value,
        radar_chart_data['efficiency'].value,
        radar_chart_data['day_dysfunction'].value,
        radar_chart_data['latency'].value,
        radar_chart_data['disturbance'].value
      ]
    };

    if (get(healthReportData, 'sleep.psqi.value') !== null) {
      createRadar(settings);
      updateRadar(sleep_data);
    }
  }, []);
  return (
    <Element>
      {get(healthReportData, 'sleep.psqi.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Element marginTop="30px">
            <Text family="GTAR" size="14px" color="#959595">
              Pittsburgh Sleep Quality Index (PSQI)
            </Text>
          </Element>
          <Element>
            <Text family="GTAM" size="14px" color="#222222">
              Sleep is assessed by the Pittsburgh Sleep Quality Index (PSQI), a
              widely used self-report survey that assesses sleep quality over a
              1-month time internal. The index produces seven component scores
              associated with sleep and one global score.
            </Text>
          </Element>
          <Flex height="500px">
            <Element width="22%" marginRight="70px" marginTop="30px">
              <Text family="GTAR" size="12px" color="#959595">
                Overall Sleep Quality
              </Text>
              <Text family="GTAM" size="32px" color="#222222">
                {get(healthReportData, 'sleep.psqi.interpretation')}
              </Text>
            </Element>
            <div
              id="sleep_chart"
              style={{ width: '70%', marginTop: '35px' }}
            ></div>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default Sleep;
